import { View } from 'react-native'
import { useTheme } from 'react-native-paper'

type NewIndicatorDotProps = {
  visible?: boolean
  accessibilityLabel: string
  /** Default 8 */
  size?: number
  /** Defaults to theme primary */
  color?: string
}

/**
 * Small filled circle for “unread / new” markers (e.g. collaborator timeline).
 */
export function NewIndicatorDot({
  visible = true,
  accessibilityLabel,
  size = 8,
  color,
}: NewIndicatorDotProps) {
  const theme = useTheme()
  if (!visible) {
    return null
  }
  const backgroundColor = color ?? theme.colors.primary
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor,
        flexShrink: 0,
      }}
      accessibilityLabel={accessibilityLabel}
    />
  )
}
